module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exchangedList"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/memberredpoint'
      },
      "replace": ""
    }
  }, [_vm._v("会员集点")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("礼品兑换")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [(_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("输入兑换码")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "234px",
      "margin-right": "15px"
    },
    attrs: {
      "placeholder": "输入4位兑换码"
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "panel-edit-btn__subshopnum",
    staticStyle: {
      "width": "158px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exchangeHandler
    }
  }, [_vm._v("兑换")])], 1) : _vm._e(), _vm._v(" "), (!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": _vm.nameChange
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  }, _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }))], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.exchangedData.records,
      "row-class-name": "el-table__row_fix",
      "id": "ex_points"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "头像",
      "min-width": "104"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "points-avatar",
          attrs: {
            "src": scope.row.avatar
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "微信昵称",
      "min-width": "114"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.nickname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "兑换时间",
      "min-width": "206"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.exchange_time))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "兑换码",
      "min-width": "124"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "礼品详情",
      "min-width": "196"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.goods_name))])]
      }
    }])
  }), _vm._v(" "), (!_vm.role.single) ? _c('el-table-column', {
    attrs: {
      "label": "兑换店铺",
      "min-width": "162"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.apply_shops.join(',')))])]
      }
    }])
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.exchangedData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": +_vm.exchangedData.count,
      "current-page": _vm.currentpage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c35a929"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exchangedcredits/exchangedcreditslist.vue
// module id = 803
// module chunks = 1